"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _showdown = require("showdown");
var _excluded = ["text", "children", "MdComponent"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var converter = new _showdown.Converter({
  tables: true,
  simplifiedAutoLink: true,
  openLinksInNewWindow: true
});
var Markdown = function Markdown(_ref) {
  var text = _ref.text,
    children = _ref.children,
    MdComponent = _ref.MdComponent,
    props = _objectWithoutProperties(_ref, _excluded);
  var source = '';
  if (text && (0, _isString["default"])(text)) {
    source = text;
  } else if (children && (0, _isString["default"])(children)) {
    source = children;
  }
  return /*#__PURE__*/_react["default"].createElement(MdComponent, _extends({}, props, {
    dangerouslySetInnerHTML: {
      __html: converter.makeHtml(source)
    }
  }));
};
Markdown.defaultProps = {
  MdComponent: 'div'
};
var _default = exports["default"] = Markdown;